/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Standings_VisibilityInputs */



/**
* | output |
* | --- |
* | "Standings Visibility" |
*
* @param {Og_Cfg_Standings_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_standings_visibility = /** @type {((inputs?: Og_Cfg_Standings_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Standings_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Visibilité du classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Visibilidad de clasificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visibilidade da Classificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visibilità Classifica")
	return /** @type {LocalizedString} */ ("Standings Visibility")
});